export const idlFactory = ({ IDL }) => {
  const Result_4 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const Result_2 = IDL.Variant({ 'ok' : IDL.Text, 'err' : IDL.Text });
  const SubscriptionStatus = IDL.Variant({
    'PendingPayment' : IDL.Null,
    'Active' : IDL.Null,
    'Cancelled' : IDL.Null,
    'Expired' : IDL.Null,
  });
  const PaymentMethod = IDL.Variant({
    'ICP' : IDL.Null,
    'CustomToken' : IDL.Text,
    'Cycles' : IDL.Null,
    'Manual' : IDL.Null,
  });
  const PaymentStatus = IDL.Variant({
    'Failed' : IDL.Null,
    'Refunded' : IDL.Null,
    'Completed' : IDL.Null,
    'Pending' : IDL.Null,
  });
  const BillingPeriod = IDL.Variant({
    'Quarterly' : IDL.Null,
    'Custom' : IDL.Nat64,
    'Monthly' : IDL.Null,
    'Yearly' : IDL.Null,
  });
  const Timestamp = IDL.Nat64;
  const PaymentRecord = IDL.Record({
    'id' : IDL.Text,
    'status' : PaymentStatus,
    'method' : PaymentMethod,
    'period' : BillingPeriod,
    'date' : Timestamp,
    'amount' : IDL.Nat64,
    'transactionId' : IDL.Opt(IDL.Text),
  });
  const SubscriptionTier = IDL.Variant({
    'Premium' : IDL.Null,
    'Enterprise' : IDL.Null,
    'Basic' : IDL.Null,
    'Custom' : IDL.Text,
  });
  const Subscription = IDL.Record({
    'id' : IDL.Text,
    'status' : SubscriptionStatus,
    'paymentMethod' : IDL.Opt(PaymentMethod),
    'paymentHistory' : IDL.Vec(PaymentRecord),
    'expiryDate' : Timestamp,
    'lastPaymentDate' : Timestamp,
    'tier' : SubscriptionTier,
    'userCanisterId' : IDL.Principal,
    'userPrincipal' : IDL.Principal,
    'autoRenew' : IDL.Bool,
    'startDate' : Timestamp,
  });
  const Result_1 = IDL.Variant({ 'ok' : Subscription, 'err' : IDL.Text });
  const AccountType = IDL.Variant({
    'Premium' : IDL.Null,
    'Enterprise' : IDL.Null,
    'Basic' : IDL.Null,
    'Custom' : IDL.Text,
  });
  const CourseVideo = IDL.Record({
    'id' : IDL.Text,
    'title' : IDL.Text,
    'duration' : IDL.Nat,
    'thumbnail' : IDL.Text,
    'order' : IDL.Nat,
    'description' : IDL.Text,
    'youtubeId' : IDL.Text,
  });
  const Course = IDL.Record({
    'id' : IDL.Text,
    'subCategory' : IDL.Opt(IDL.Text),
    'title' : IDL.Text,
    'thumbnailUrl' : IDL.Text,
    'ratingCount' : IDL.Nat,
    'createdAt' : IDL.Nat64,
    'totalDuration' : IDL.Nat,
    'tags' : IDL.Vec(IDL.Text),
    'description' : IDL.Text,
    'isActive' : IDL.Bool,
    'instructorId' : IDL.Principal,
    'updatedAt' : IDL.Nat64,
    'totalVideos' : IDL.Nat,
    'category' : IDL.Text,
    'rating' : IDL.Float64,
    'requiredAccountType' : AccountType,
    'videos' : IDL.Vec(CourseVideo),
    'instructorName' : IDL.Text,
    'enrollmentCount' : IDL.Nat,
  });
  const TemplateCategory = IDL.Record({
    'id' : IDL.Text,
    'featuredTemplates' : IDL.Vec(IDL.Text),
    'icon' : IDL.Opt(IDL.Text),
    'name' : IDL.Text,
    'templateCount' : IDL.Nat,
    'description' : IDL.Opt(IDL.Text),
    'parentCategory' : IDL.Opt(IDL.Text),
    'subCategories' : IDL.Vec(IDL.Text),
  });
  const Result_15 = IDL.Variant({ 'ok' : TemplateCategory, 'err' : IDL.Text });
  const TemplatePromotion = IDL.Record({
    'id' : IDL.Text,
    'endDate' : IDL.Nat64,
    'promotionFee' : IDL.Opt(IDL.Nat64),
    'templateId' : IDL.Text,
    'customMessage' : IDL.Opt(IDL.Text),
    'spotlightPosition' : IDL.Opt(IDL.Nat),
    'creatorPaid' : IDL.Bool,
    'discount' : IDL.Opt(IDL.Nat),
    'promotionType' : IDL.Text,
    'startDate' : IDL.Nat64,
  });
  const Result_13 = IDL.Variant({ 'ok' : TemplatePromotion, 'err' : IDL.Text });
  const TemplateReview = IDL.Record({
    'id' : IDL.Text,
    'status' : IDL.Text,
    'title' : IDL.Opt(IDL.Text),
    'created' : IDL.Nat64,
    'templateId' : IDL.Text,
    'isVerifiedPurchase' : IDL.Bool,
    'reviewerId' : IDL.Principal,
    'comment' : IDL.Text,
    'replyFromCreator' : IDL.Opt(IDL.Text),
    'rating' : IDL.Nat,
    'helpfulCount' : IDL.Nat,
  });
  const Result_8 = IDL.Variant({ 'ok' : TemplateReview, 'err' : IDL.Text });
  const Result_11 = IDL.Variant({
    'ok' : IDL.Vec(Subscription),
    'err' : IDL.Text,
  });
  const Result_16 = IDL.Variant({ 'ok' : IDL.Principal, 'err' : IDL.Text });
  const CanisterDefaultSettings = IDL.Record({
    'durationInDays' : IDL.Nat,
    'freezingThreshold' : IDL.Opt(IDL.Nat),
    'memoryGB' : IDL.Nat,
    'computeAllocation' : IDL.Nat,
    'cyclesAmount' : IDL.Nat,
  });
  const Result_7 = IDL.Variant({
    'ok' : CanisterDefaultSettings,
    'err' : IDL.Text,
  });
  const ResourceUsage = IDL.Record({ 'memory' : IDL.Nat, 'compute' : IDL.Nat });
  const Result_14 = IDL.Variant({
    'ok' : IDL.Record({
      'claudeApiKeySet' : IDL.Bool,
      'commissionAddressSet' : IDL.Bool,
    }),
    'err' : IDL.Text,
  });
  const DailyCount = IDL.Record({ 'date' : IDL.Text, 'count' : IDL.Nat });
  const TemplatePricing = IDL.Record({
    'subscription' : IDL.Opt(IDL.Bool),
    'promotionExpiresAt' : IDL.Opt(IDL.Nat64),
    'acceptedPaymentMethods' : IDL.Opt(IDL.Vec(IDL.Text)),
    'currency' : IDL.Text,
    'discount' : IDL.Opt(IDL.Nat),
    'promotionalPrice' : IDL.Opt(IDL.Nat64),
    'paymentTerms' : IDL.Opt(IDL.Text),
    'price' : IDL.Nat64,
  });
  const TemplateMetadata = IDL.Record({
    'id' : IDL.Text,
    'created' : IDL.Nat64,
    'thumbnail' : IDL.Opt(IDL.Text),
    'publishingStatus' : IDL.Text,
    'name' : IDL.Text,
    'tags' : IDL.Vec(IDL.Text),
    'description' : IDL.Text,
    'author' : IDL.Principal,
    'pricing' : IDL.Opt(TemplatePricing),
    'version' : IDL.Text,
    'isFeatured' : IDL.Bool,
    'userCanisterId' : IDL.Principal,
    'updated' : IDL.Nat64,
    'category' : IDL.Text,
    'rating' : IDL.Opt(IDL.Float64),
    'downloads' : IDL.Nat,
  });
  const LogEntry = IDL.Record({
    'level' : IDL.Text,
    'message' : IDL.Text,
    'timestamp' : IDL.Text,
    'details' : IDL.Opt(IDL.Text),
  });
  const MarketplaceConfig = IDL.Record({
    'refundPeriodDays' : IDL.Nat,
    'featuredTemplateFee' : IDL.Nat64,
    'allowedCategories' : IDL.Vec(IDL.Text),
    'maxTemplatePrice' : IDL.Nat64,
    'minTemplatePrice' : IDL.Nat64,
    'payoutSchedule' : IDL.Text,
    'platformFeePercentage' : IDL.Nat,
    'moderationEnabled' : IDL.Bool,
    'allowedLicenseTypes' : IDL.Vec(IDL.Text),
  });
  const TemplatePurchase = IDL.Record({
    'id' : IDL.Text,
    'status' : IDL.Text,
    'transactionHash' : IDL.Opt(IDL.Text),
    'refundReason' : IDL.Opt(IDL.Text),
    'templateId' : IDL.Text,
    'downloadKey' : IDL.Opt(IDL.Text),
    'purchasedAt' : IDL.Nat64,
    'version' : IDL.Text,
    'licenseKey' : IDL.Opt(IDL.Text),
    'buyerId' : IDL.Principal,
    'sellerId' : IDL.Principal,
    'price' : IDL.Nat64,
  });
  const Result_9 = IDL.Variant({ 'ok' : TemplatePurchase, 'err' : IDL.Text });
  const PaymentRecord__1 = IDL.Record({
    'method' : IDL.Text,
    'timestamp' : IDL.Int,
    'amount' : IDL.Nat64,
  });
  const Metadata = IDL.Record({
    'balance' : IDL.Nat,
    'cycleBalance' : IDL.Nat64,
    'moduleHash' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'lastUpdated' : IDL.Nat64,
    'totalKeys' : IDL.Nat,
    'memoryUsage' : IDL.Nat64,
    'version' : IDL.Text,
    'uptime' : IDL.Nat64,
    'totalUsers' : IDL.Nat,
    'idleCyclesBurnedPerDay' : IDL.Nat,
    'stableStateSize' : IDL.Nat,
    'stableMemoryUsage' : IDL.Nat,
    'heapMemoryUsage' : IDL.Nat64,
    'memorySize' : IDL.Nat,
  });
  const Result_12 = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(SubscriptionTier, IDL.Nat)),
    'err' : IDL.Text,
  });
  const TierFeatures = IDL.Record({
    'computeUnitsAllowed' : IDL.Nat,
    'maxCollaborators' : IDL.Nat,
    'canistersAllowed' : IDL.Nat,
    'marketplaceCommissionPercent' : IDL.Nat,
    'memoryAllowanceGB' : IDL.Nat,
    'templateDiscountPercent' : IDL.Nat,
    'analyticsAccess' : IDL.Bool,
    'prioritySupport' : IDL.Bool,
    'allowCustomDomains' : IDL.Bool,
  });
  const Result_3 = IDL.Variant({ 'ok' : TemplateMetadata, 'err' : IDL.Text });
  const FileContent = IDL.Variant({
    'Binary' : IDL.Vec(IDL.Nat8),
    'Text' : IDL.Text,
  });
  const ChunkId = IDL.Nat;
  const CodeArtifact = IDL.Record({
    'id' : IDL.Text,
    'content' : IDL.Opt(FileContent),
    'path' : IDL.Text,
    'size' : IDL.Nat,
    'mimeType' : IDL.Text,
    'fileName' : IDL.Text,
    'lastModified' : IDL.Int,
    'language' : IDL.Text,
    'version' : IDL.Nat,
    'projectId' : IDL.Text,
    'chunks' : IDL.Opt(IDL.Vec(IDL.Tuple(ChunkId, IDL.Nat))),
  });
  const Result_10 = IDL.Variant({
    'ok' : IDL.Vec(CodeArtifact),
    'err' : IDL.Text,
  });
  const TemplateAnalytics = IDL.Record({
    'revenue' : IDL.Nat64,
    'views' : IDL.Nat,
    'purchases' : IDL.Nat,
  });
  const ImageAsset = IDL.Record({
    'height' : IDL.Opt(IDL.Nat),
    'data' : IDL.Vec(IDL.Nat8),
    'name' : IDL.Text,
    'mimeType' : IDL.Text,
    'sizeBytes' : IDL.Nat,
    'width' : IDL.Opt(IDL.Nat),
    'uploadedAt' : IDL.Nat64,
  });
  const TemplateStats = IDL.Record({
    'popularityScore' : IDL.Opt(IDL.Float64),
    'created' : IDL.Nat64,
    'revenue' : IDL.Opt(IDL.Nat64),
    'views' : IDL.Nat,
    'usageCount' : IDL.Nat,
    'updated' : IDL.Nat64,
    'conversionRate' : IDL.Opt(IDL.Float64),
    'averageDailyDownloads' : IDL.Opt(IDL.Float64),
    'rating' : IDL.Opt(IDL.Float64),
    'reviewCount' : IDL.Nat,
    'downloads' : IDL.Nat,
  });
  const TemplateVersion = IDL.Record({
    'publishedAt' : IDL.Nat64,
    'isDeprecated' : IDL.Bool,
    'downloadUrl' : IDL.Text,
    'releaseNotes' : IDL.Opt(IDL.Text),
    'version' : IDL.Text,
    'changes' : IDL.Vec(IDL.Text),
  });
  const TemplateLicense = IDL.Record({
    'requiresAttribution' : IDL.Bool,
    'allowModification' : IDL.Bool,
    'licenseType' : IDL.Text,
    'customTerms' : IDL.Opt(IDL.Text),
    'allowCommercialUse' : IDL.Bool,
  });
  const Template = IDL.Record({
    'id' : IDL.Text,
    'creatorPayoutAddress' : IDL.Opt(IDL.Text),
    'previewImageAssets' : IDL.Opt(IDL.Vec(ImageAsset)),
    'subCategory' : IDL.Opt(IDL.Text),
    'thumbnail' : IDL.Opt(IDL.Text),
    'installationInstructions' : IDL.Opt(IDL.Text),
    'publishingStatus' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'documentation' : IDL.Opt(IDL.Text),
    'name' : IDL.Text,
    'tags' : IDL.Vec(IDL.Text),
    'supportUrl' : IDL.Opt(IDL.Text),
    'videoPreview' : IDL.Opt(IDL.Text),
    'description' : IDL.Text,
    'downloadUrl' : IDL.Text,
    'author' : IDL.Principal,
    'pricing' : IDL.Opt(TemplatePricing),
    'version' : IDL.Text,
    'stats' : IDL.Opt(TemplateStats),
    'versionHistory' : IDL.Opt(IDL.Vec(TemplateVersion)),
    'currentVersion' : TemplateVersion,
    'isFeatured' : IDL.Bool,
    'projectId' : IDL.Text,
    'creatorAccount' : IDL.Principal,
    'moderationStatus' : IDL.Opt(IDL.Text),
    'dependencies' : IDL.Opt(IDL.Vec(IDL.Text)),
    'demoUrl' : IDL.Opt(IDL.Text),
    'category' : IDL.Text,
    'searchKeywords' : IDL.Opt(IDL.Vec(IDL.Text)),
    'requirements' : IDL.Opt(IDL.Text),
    'license' : IDL.Opt(TemplateLicense),
    'previewImages' : IDL.Opt(IDL.Vec(IDL.Text)),
    'thumbnailImage' : IDL.Opt(ImageAsset),
  });
  const Result_6 = IDL.Variant({ 'ok' : MarketplaceConfig, 'err' : IDL.Text });
  const Result_5 = IDL.Variant({ 'ok' : IDL.Float64, 'err' : IDL.Text });
  const TierPricing = IDL.Record({
    'yearlyDiscountPercent' : IDL.Nat,
    'monthlyCost' : IDL.Nat64,
  });
  const Result = IDL.Variant({
    'ok' : IDL.Record({ 'receivedChunks' : IDL.Nat, 'totalChunks' : IDL.Nat }),
    'err' : IDL.Text,
  });
  return IDL.Service({
    '__get_candid_interface_tmp_hack' : IDL.Func([], [IDL.Text], ['query']),
    'addAdmin' : IDL.Func([IDL.Principal], [Result_4], []),
    'addDailyCanisterCount' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'addDailyDeployment' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'addDailyProjectCreation' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'addDailyUserCount' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'addPurchaseRecord' : IDL.Func([IDL.Int, IDL.Nat64, IDL.Text], [], []),
    'addSearchQuery' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'addSubscriptionPayment' : IDL.Func([IDL.Int, IDL.Nat64, IDL.Text], [], []),
    'addTestAdminPrincipal' : IDL.Func([IDL.Text], [Result_2], []),
    'addTestUser' : IDL.Func([IDL.Text, IDL.Text, IDL.Text], [Result_2], []),
    'addTestUserPlatformCanister' : IDL.Func(
        [IDL.Text, IDL.Text],
        [Result_2],
        [],
      ),
    'addTestUsernameToCanister' : IDL.Func(
        [IDL.Text, IDL.Text],
        [Result_2],
        [],
      ),
    'addTestWhitelistedUser' : IDL.Func([IDL.Text], [Result_2], []),
    'adminReleaseUsername' : IDL.Func([IDL.Text], [Result_4], []),
    'cancelSubscription' : IDL.Func([IDL.Text], [Result_1], []),
    'changeSubscriptionTier' : IDL.Func([SubscriptionTier], [Result_1], []),
    'checkExpiredSubscriptions' : IDL.Func([], [Result_4], []),
    'clearLogs' : IDL.Func([], [Result_4], []),
    'createCanisterWithSettings' : IDL.Func(
        [IDL.Principal, IDL.Nat, IDL.Nat, IDL.Opt(IDL.Nat), IDL.Nat, IDL.Nat],
        [Result_2],
        [],
      ),
    'createCourse' : IDL.Func([Course], [Result_2], []),
    'createOrUpdateCategory' : IDL.Func([TemplateCategory], [Result_15], []),
    'createOrUpdatePromotion' : IDL.Func([TemplatePromotion], [Result_13], []),
    'createReview' : IDL.Func([TemplateReview], [Result_8], []),
    'createSubscription' : IDL.Func(
        [
          IDL.Principal,
          SubscriptionTier,
          IDL.Opt(PaymentMethod),
          IDL.Bool,
          BillingPeriod,
        ],
        [Result_1],
        [],
      ),
    'deleteCanister' : IDL.Func([IDL.Principal], [Result_2], []),
    'deleteCategory' : IDL.Func([IDL.Text], [Result_2], []),
    'deleteCourse' : IDL.Func([IDL.Text], [Result_2], []),
    'deployStoredWasm' : IDL.Func(
        [IDL.Text, IDL.Principal, IDL.Principal],
        [Result_2],
        [],
      ),
    'deployToExistingCanister' : IDL.Func(
        [IDL.Principal, IDL.Vec(IDL.Nat8)],
        [Result_2],
        [],
      ),
    'diagnosticEOPState' : IDL.Func(
        [],
        [
          IDL.Record({
            'userSample' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
            'hashMapSizes' : IDL.Record({
              'usernameToCanister' : IDL.Nat,
              'courses' : IDL.Nat,
              'userPlatformCanisters' : IDL.Nat,
              'whitelistMap' : IDL.Nat,
            }),
            'stableArraySizes' : IDL.Record({
              'whitelistedUsers' : IDL.Nat,
              'usernameToCanisterEntries' : IDL.Nat,
              'coursesData' : IDL.Nat,
              'userPlatformCanistersEntries' : IDL.Nat,
            }),
          }),
        ],
        ['query'],
      ),
    'finalizeWasmUpload' : IDL.Func([IDL.Text], [Result_2], []),
    'getActivePromotions' : IDL.Func(
        [],
        [IDL.Vec(TemplatePromotion)],
        ['query'],
      ),
    'getAdminList' : IDL.Func([], [IDL.Vec(IDL.Text)], []),
    'getAllCategories' : IDL.Func([], [IDL.Vec(TemplateCategory)], ['query']),
    'getAllCourses' : IDL.Func([], [IDL.Vec(Course)], ['query']),
    'getAllRegisteredUsernames' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Principal))],
        [],
      ),
    'getAllSubscriptions' : IDL.Func([], [Result_11], []),
    'getAllUserCanisterEntries' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Principal))],
        ['query'],
      ),
    'getAllWhitelistedUsers' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Principal))],
        [],
      ),
    'getCanisterByUsername' : IDL.Func([IDL.Text], [Result_16], ['query']),
    'getCanisterCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'deletedCanisters' : IDL.Nat,
            'totalCanisters' : IDL.Nat,
            'activeCanisters' : IDL.Nat,
            'failedOperations' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getCanisterDefaultSettings' : IDL.Func([], [Result_7], ['query']),
    'getCanisterResources' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, ResourceUsage))],
        ['query'],
      ),
    'getCategory' : IDL.Func([IDL.Text], [Result_15], ['query']),
    'getClaudeApiKey' : IDL.Func([], [Result_2], []),
    'getCommissionAddress' : IDL.Func([], [Result_2], []),
    'getConfigurationStatus' : IDL.Func([], [Result_14], []),
    'getCourseAccess' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getCourseById' : IDL.Func([IDL.Text], [IDL.Opt(Course)], ['query']),
    'getCourseCategories' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getCourseCounters' : IDL.Func(
        [],
        [IDL.Record({ 'totalCourses' : IDL.Nat, 'totalAccesses' : IDL.Nat })],
        ['query'],
      ),
    'getCourseEnrollments' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getCoursesByAccountType' : IDL.Func(
        [AccountType],
        [IDL.Vec(Course)],
        ['query'],
      ),
    'getCoursesByCategory' : IDL.Func([IDL.Text], [IDL.Vec(Course)], ['query']),
    'getCoursesByInstructor' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(Course)],
        ['query'],
      ),
    'getDailyCanisterCounts' : IDL.Func([], [IDL.Vec(DailyCount)], ['query']),
    'getDailyDeployments' : IDL.Func([], [IDL.Vec(DailyCount)], ['query']),
    'getDailyProjectCreation' : IDL.Func([], [IDL.Vec(DailyCount)], ['query']),
    'getDailyUserCounts' : IDL.Func([], [IDL.Vec(DailyCount)], ['query']),
    'getDeploymentCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'failedDeployments' : IDL.Nat,
            'totalDeployments' : IDL.Nat,
            'successfulDeployments' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getDeploymentsByTarget' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getDiscountedTemplates' : IDL.Func(
        [],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getEOPStateInfo' : IDL.Func(
        [],
        [
          IDL.Record({
            'deploymentTimestamp' : IDL.Int,
            'counts' : IDL.Record({
              'whitelistedUsers' : IDL.Nat,
              'usernameToCanister' : IDL.Nat,
              'adminPrincipals' : IDL.Nat,
              'userPlatformCanisters' : IDL.Nat,
              'users' : IDL.Nat,
            }),
          }),
        ],
        ['query'],
      ),
    'getFeaturedTemplates' : IDL.Func(
        [],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getLogs' : IDL.Func([IDL.Opt(IDL.Principal)], [IDL.Vec(LogEntry)], []),
    'getMarketplaceConfig' : IDL.Func([], [MarketplaceConfig], ['query']),
    'getMarketplaceCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'totalSales' : IDL.Nat,
            'totalRevenue' : IDL.Nat64,
            'totalTemplates' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getMultipleUserCanisters' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Opt(IDL.Principal)))],
        ['query'],
      ),
    'getNewestTemplates' : IDL.Func([], [IDL.Vec(TemplateMetadata)], ['query']),
    'getPopularTemplates' : IDL.Func(
        [],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getProjectCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'deletedProjects' : IDL.Nat,
            'activeProjects' : IDL.Nat,
            'totalProjects' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getProjectsByType' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getPromotion' : IDL.Func([IDL.Text], [Result_13], ['query']),
    'getPromotionsForTemplate' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplatePromotion)],
        ['query'],
      ),
    'getPurchase' : IDL.Func([IDL.Text], [Result_9], ['query']),
    'getPurchaseHistory' : IDL.Func([], [IDL.Vec(PaymentRecord__1)], ['query']),
    'getPurchasesByBuyer' : IDL.Func(
        [],
        [IDL.Vec(TemplatePurchase)],
        ['query'],
      ),
    'getPurchasesBySeller' : IDL.Func(
        [],
        [IDL.Vec(TemplatePurchase)],
        ['query'],
      ),
    'getPurchasesForTemplate' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplatePurchase)],
        ['query'],
      ),
    'getReview' : IDL.Func([IDL.Text], [Result_8], ['query']),
    'getReviewsForTemplate' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplateReview)],
        ['query'],
      ),
    'getSearchQueries' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getStateMetadata' : IDL.Func([IDL.Opt(IDL.Principal)], [Metadata], []),
    'getSubscription' : IDL.Func([IDL.Text], [Result_1], ['query']),
    'getSubscriptionCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'cancellations' : IDL.Nat,
            'totalRevenue' : IDL.Nat64,
            'activeSubscriptions' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getSubscriptionCountsByTier' : IDL.Func([], [Result_12], []),
    'getSubscriptionPayments' : IDL.Func(
        [],
        [IDL.Vec(PaymentRecord__1)],
        ['query'],
      ),
    'getSubscriptionTierFeatures' : IDL.Func(
        [SubscriptionTier],
        [IDL.Opt(TierFeatures)],
        ['query'],
      ),
    'getSubscriptionTierPricing' : IDL.Func(
        [SubscriptionTier],
        [IDL.Nat64],
        ['query'],
      ),
    'getSubscriptionTiers' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getSubscriptionsByStatus' : IDL.Func(
        [SubscriptionStatus],
        [Result_11],
        [],
      ),
    'getTemplateCategories' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))],
        ['query'],
      ),
    'getTemplateMetadata' : IDL.Func([IDL.Text], [Result_3], ['query']),
    'getTemplateProjectFiles' : IDL.Func([IDL.Text, IDL.Text], [Result_10], []),
    'getTemplateReviewStats' : IDL.Func(
        [IDL.Text],
        [
          IDL.Record({
            'averageRating' : IDL.Float64,
            'verifiedPurchasePercentage' : IDL.Float64,
            'ratingDistribution' : IDL.Vec(IDL.Nat),
            'totalReviews' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getTemplateStats' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, TemplateAnalytics))],
        ['query'],
      ),
    'getTemplatesByCategory' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getTemplatesByTag' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getTemplatesByUser' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'getUserBatchInfo' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [
          IDL.Vec(
            IDL.Record({
              'principal' : IDL.Principal,
              'subscription' : IDL.Opt(
                IDL.Record({
                  'id' : IDL.Text,
                  'status' : IDL.Text,
                  'expiresAt' : IDL.Int,
                  'tier' : IDL.Text,
                })
              ),
              'isAdmin' : IDL.Bool,
              'lastActive' : IDL.Opt(IDL.Int),
              'canisterId' : IDL.Opt(IDL.Principal),
            })
          ),
        ],
        ['query'],
      ),
    'getUserCounters' : IDL.Func(
        [],
        [
          IDL.Record({
            'activeUsers' : IDL.Nat,
            'whitelistedUsers' : IDL.Nat,
            'totalUsers' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getUserCreationDate' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(IDL.Int)],
        ['query'],
      ),
    'getUserLastActive' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Int))],
        ['query'],
      ),
    'getUserPlatformCanister' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(IDL.Principal)],
        [],
      ),
    'getUserPrincipalByCanister' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(IDL.Principal)],
        [],
      ),
    'getUserRating' : IDL.Func([IDL.Principal], [IDL.Float64], ['query']),
    'getUserSubscription' : IDL.Func([], [Result_1], ['query']),
    'getUserSubscriptionInfo' : IDL.Func(
        [IDL.Principal],
        [
          IDL.Record({
            'status' : IDL.Opt(IDL.Text),
            'expiryDate' : IDL.Opt(IDL.Nat64),
            'tier' : IDL.Opt(IDL.Text),
            'subscriptionId' : IDL.Opt(IDL.Text),
            'hasSubscription' : IDL.Bool,
          }),
        ],
        ['query'],
      ),
    'hasUserPurchasedTemplate' : IDL.Func(
        [IDL.Text, IDL.Principal],
        [IDL.Bool],
        ['query'],
      ),
    'hasUserReviewedTemplate' : IDL.Func([IDL.Text], [IDL.Bool], ['query']),
    'inspectAdminPrincipals' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'inspectCanisterDefaultSettings' : IDL.Func(
        [],
        [IDL.Opt(CanisterDefaultSettings)],
        ['query'],
      ),
    'inspectUserPlatformCanisters' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        ['query'],
      ),
    'inspectUsernameToCanister' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        ['query'],
      ),
    'inspectUsers' : IDL.Func(
        [IDL.Nat],
        [
          IDL.Vec(
            IDL.Tuple(
              IDL.Text,
              IDL.Record({ 'name' : IDL.Text, 'email' : IDL.Text }),
            )
          ),
        ],
        ['query'],
      ),
    'inspectWhitelistedUsers' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        ['query'],
      ),
    'isAdmin' : IDL.Func([], [IDL.Bool], ['query']),
    'isConfigurationComplete' : IDL.Func([], [IDL.Bool], ['query']),
    'isPrincipalAdmin' : IDL.Func([IDL.Principal], [IDL.Bool], []),
    'isUserWhitelisted' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
    'markReviewHelpful' : IDL.Func([IDL.Text], [Result_8], []),
    'processSubscriptionPayment' : IDL.Func(
        [IDL.Text, IDL.Nat64, PaymentMethod, IDL.Opt(IDL.Text), BillingPeriod],
        [Result_1],
        [],
      ),
    'recordPurchase' : IDL.Func([TemplatePurchase], [Result_9], []),
    'recordTemplateSale' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Nat64],
        [Result_4],
        [],
      ),
    'recordUserCreation' : IDL.Func([], [], []),
    'registerForWhitelist' : IDL.Func([IDL.Text], [IDL.Text], []),
    'registerTemplate' : IDL.Func([Template, IDL.Principal], [Result_2], []),
    'registerUsername' : IDL.Func([IDL.Text], [Result_4], []),
    'removeAdmin' : IDL.Func([IDL.Principal], [Result_4], []),
    'removeFromWhitelist' : IDL.Func(
        [IDL.Opt(IDL.Text), IDL.Opt(IDL.Principal)],
        [Result_2],
        [],
      ),
    'removeTestAdminPrincipal' : IDL.Func([IDL.Text], [Result_2], []),
    'removeTestUser' : IDL.Func([IDL.Text], [Result_2], []),
    'removeTestUserPlatformCanister' : IDL.Func([IDL.Text], [Result_2], []),
    'removeTestUsernameToCanister' : IDL.Func([IDL.Text], [Result_2], []),
    'removeTestWhitelistedUser' : IDL.Func([IDL.Text], [Result_2], []),
    'removeUserPlatformCanister' : IDL.Func([IDL.Principal], [Result_2], []),
    'removeUserSubscription' : IDL.Func([IDL.Text], [Result_2], []),
    'replyToReview' : IDL.Func([IDL.Text, IDL.Text], [Result_8], []),
    'resetSubscriptionMappingsExcept' : IDL.Func(
        [IDL.Principal],
        [Result_2],
        [],
      ),
    'searchTemplates' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(TemplateMetadata)],
        ['query'],
      ),
    'setClaudeApiKey' : IDL.Func([IDL.Text], [Result_4], []),
    'setCommissionAddress' : IDL.Func([IDL.Text], [Result_4], []),
    'startWasmUploadSession' : IDL.Func(
        [IDL.Text, IDL.Nat, IDL.Nat],
        [Result_2],
        [],
      ),
    'syncUserAccountType' : IDL.Func([IDL.Principal], [Result_2], []),
    'traceSubscriptionState' : IDL.Func([], [Result_2], []),
    'unregisterTemplate' : IDL.Func([IDL.Text], [Result_2], []),
    'unregisterUsername' : IDL.Func([IDL.Text], [Result_4], []),
    'updateCanisterCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateCanisterDefaultSettings' : IDL.Func(
        [CanisterDefaultSettings],
        [Result_7],
        [],
      ),
    'updateCanisterResources' : IDL.Func(
        [IDL.Principal, IDL.Nat, IDL.Nat],
        [],
        [],
      ),
    'updateCourse' : IDL.Func([Course], [Result_2], []),
    'updateCourseAccess' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateCourseCategory' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateCourseCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateCourseEnrollments' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateDeploymentCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateDeploymentTarget' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateMarketplaceConfig' : IDL.Func([MarketplaceConfig], [Result_6], []),
    'updateMarketplaceCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateMarketplaceRevenue' : IDL.Func([IDL.Nat64], [], []),
    'updateProjectCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateProjectType' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateSellerReputation' : IDL.Func([IDL.Principal], [Result_5], []),
    'updateSubscriptionCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateSubscriptionRevenue' : IDL.Func([IDL.Nat64], [], []),
    'updateSubscriptionTier' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateSubscriptionTierFeatures' : IDL.Func(
        [SubscriptionTier, TierFeatures],
        [Result_4],
        [],
      ),
    'updateSubscriptionTierPricing' : IDL.Func(
        [SubscriptionTier, TierPricing],
        [Result_4],
        [],
      ),
    'updateTemplateCategory' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateTemplateMetadata' : IDL.Func(
        [
          IDL.Text,
          IDL.Record({
            'thumbnail' : IDL.Opt(IDL.Text),
            'publishingStatus' : IDL.Opt(IDL.Text),
            'name' : IDL.Opt(IDL.Text),
            'tags' : IDL.Opt(IDL.Vec(IDL.Text)),
            'description' : IDL.Opt(IDL.Text),
            'pricing' : IDL.Opt(TemplatePricing),
            'version' : IDL.Opt(IDL.Text),
            'isFeatured' : IDL.Opt(IDL.Bool),
            'category' : IDL.Opt(IDL.Text),
          }),
        ],
        [Result_3],
        [],
      ),
    'updateTemplateStats' : IDL.Func(
        [IDL.Text, IDL.Nat, IDL.Nat, IDL.Nat64],
        [],
        [],
      ),
    'updateTestCanisterDefaults' : IDL.Func(
        [CanisterDefaultSettings],
        [Result_2],
        [],
      ),
    'updateUserCounter' : IDL.Func([IDL.Text, IDL.Nat], [], []),
    'updateUserLastActive' : IDL.Func([IDL.Principal, IDL.Int], [], []),
    'updateUserSubscription' : IDL.Func(
        [
          IDL.Text,
          IDL.Record({
            'status' : IDL.Opt(SubscriptionStatus),
            'paymentMethod' : IDL.Opt(PaymentMethod),
            'expiryDate' : IDL.Opt(Timestamp),
            'tier' : IDL.Opt(SubscriptionTier),
            'autoRenew' : IDL.Opt(IDL.Bool),
          }),
        ],
        [Result_1],
        [],
      ),
    'uploadWasmChunk' : IDL.Func(
        [IDL.Text, IDL.Nat, IDL.Vec(IDL.Nat8)],
        [Result],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
